import type { FC } from "react";
import clsx from "clsx";
import { useLocale } from "hooks";
import translation from "./translation";
import ConferenceCard from "./ConferenceCard";
import CommonContainer from "components/SecondaryContainer";
import Link from "next/link";

interface IProps {
  conferences: Array<any>;
}

const RelatedConferences: FC<IProps> = ({ conferences }) => {
  const { isRTL, locale } = useLocale();

  return (
    <section className={"tw-bg-[#EFF2F9]"}>
      <div className="tw-px-4 md:tw-px-0">
        <CommonContainer>
          <div className="tw-pt-[30px] xxxl:tw-pt-10 tw-pb-[50px] xxxl:tw-pb-[66.5px]">
            <div className="tw-flex tw-justify-between tw-h-fit tw-w-full">
              <h5
                className={clsx(
                  "tw-text-[#344456] tw-font-bold tw-text-base xxxl:tw-text-[21.27px] tw-border-solid tw-border-y-0 tw-border-[#007FAC]",
                  {
                    "tw-border-r-4 tw-border-l-0 tw-pr-2.5": isRTL,
                    "tw-border-l-4 tw-border-r-0 tw-pl-2.5": !isRTL,
                  }
                )}
              >
                {translation?.[locale]?.RELATED_ITEMS}
              </h5>
              <Link href="/conferences" passHref prefetch={false}>
                <a className="tw-flex tw-items-center md:tw-text-sm xxxl:tw-text-[18.61px] tw-font-medium tw-text-[#007FAC] hover:tw-text-[#007FAC]/70 tw-transition-all tw-group">
                  <span
                    className={clsx({ "tw-ml-3": isRTL, "tw-mr-3": !isRTL })}
                  >
                    {translation[locale]?.SEE_MORE}
                  </span>
                  <svg
                    width="8"
                    height="13"
                    viewBox="0 0 8 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={clsx(
                      "tw-relative tw-transition-all tw-fill-[#007FAC] group-hover:tw-fill-[#007FAC]/70",
                      {
                        "tw-right-0 group-hover:tw-right-1": isRTL,
                        "tw-left-0 group-hover:tw-left-1": !isRTL,
                      }
                    )}
                    style={!isRTL ? { transform: "rotate(180deg)" } : {}}
                  >
                    <path
                      d="M7.41992 1.58981L2.82992 6.17981L7.41992 10.7698L5.99992 12.1798L-7.84636e-05 6.17981L5.99992 0.17981L7.41992 1.58981Z"
                      fill=""
                    />
                  </svg>
                </a>
              </Link>
            </div>
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-x-[30px] lg:tw-gap-x-[75px] xxxl:tw-gap-x-[99.73px] tw-gap-y-[30px] tw-mt-[30px]">
              {conferences?.slice(0, 3)?.map((item, i) => (
                <ConferenceCard item={item} key={i} />
              ))}
            </div>
          </div>
        </CommonContainer>
      </div>
    </section>
  );
};

export default RelatedConferences;
